import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-12 place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import EPShrubs from '@/assets/Projects/EagleProjectPhotos/EPShrubs.png';
import EPBenches from '@/assets/Projects/EagleProjectPhotos/EPBenches.png';
import { useImageViewer } from '@/features/composables/useImageViewer';

export default /*@__PURE__*/_defineComponent({
  __name: 'EagleProjectSpec',
  setup(__props) {

const { openImageMenu } = useImageViewer();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'Eagle Project for LCA',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Project Manager & Leader"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "April 2022 - August 2022")
        ], -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " As part of my journey to Eagle Scout, I returned to my grade school, Lakewood Catholic Academy, to give back after all that they had given me. Given my experience in landscaping and leadership, I felt particularly drawn to the 2nd most used entrance to LCA, yet this entrance had almost zero life to it. A statue of Mary dedicated to a past faculty member stood alone, and I knew that needed to change. "),
          _createElementVNode("span", { class: "block" }, [
            _createTextVNode(" Over the first 2 months, I wrote a 10-page project proposal, detailing the 3 main areas of landscaping revamp that I would be targeting as well as procurement of materials, labor, and $1000 of funding for the project. My drive was restless, and I was approved by my troop's Eagle Project board of 8 members, my Scoutmaster, and Lake Erie Council all within 1 week. "),
            _createElementVNode("br"),
            _createTextVNode(" From here, I pieced together a 30-page project plan, procuring materials/labor and scheduling the project at the same time. Over a single weekend, I organized and led over 20 Scouts and adults in installing 20 new perennials, a gravel seating area with 2 benches, and a new flower bed around the Mary statue in a grand total of 200 hours of service. Within two days of the project, I completed my 10-page project report and had my project approved by my Scoutmaster and Lake Erie Council as well. "),
            _createElementVNode("br"),
            _createTextVNode(" To this day, LCA students and faculty use this space almost daily in season, and I often find myself reading in this space when I'm in the area. ")
          ]),
          _createElementVNode("a", {
            href: "https://drive.google.com/drive/folders/1PQ0kxLRNEFaV2E9w1UQO3OjVbdjeVT2S?usp=sharing",
            target: "_blank",
            class: "link-in-text"
          }, "Photos!")
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-full h-auto rounded-lg cursor-pointer",
            src: _unref(EPShrubs),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(EPShrubs), 'Eagle Project Shrubs', $event.currentTarget)))
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            class: "w-full h-auto rounded-lg cursor-pointer",
            src: _unref(EPBenches),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openImageMenu)(_unref(EPBenches), 'Eagle Project Benches', $event.currentTarget)))
          }, null, 8, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})